import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';
import './Alert.scss';

const Alert = ({ type, msgId, defaultMessage, values }) =>
	<div className={`alert alert-${type}`} role="alert">
		<FormattedMessage
			id={msgId}
			values={values}
			defaultMessage={defaultMessage}
		/>
	</div>;

Alert.propTypes = {
	type: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
	msgId: PropTypes.string.isRequired,
	defaultMessage: PropTypes.string,
	values: PropTypes.object,
};

Alert.defaultProps = {
	type: 'info',
	defaultMessage: '',
	values: {},
};

export default Alert;



// WEBPACK FOOTER //
// ./src/ui/components/Alert/index.js